import Modal from 'react-bootstrap/Modal';
import { FaCheckCircle } from "react-icons/fa";
import ActionButtonGradient from '../../../../components/button/ActionButtonGradient';

const RatingGuidance = ({
    show, 
    handleClose 
    }) => {

    return (
        <Modal show={show} onHide={handleClose} dialogClassName='spmo-justification-modal' backdrop="static">
            <Modal.Header style={{ display: "flex", justifyContent:"center", alignItems: "center", flexDirection: "column" }}>
            <Modal.Title>
                <div >
                <b>A+ Rating Guidance</b>
                <p style={{ fontSize: "16px", marginBottom: "0" }}>Guidance to calibrate employee to an A+ rating</p>
                </div>
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div align="left">
                <p>Calibrator are allowed to nominate employee for A+ rating if the employee fulfill <b>atleast 1 out of the 2</b> criteria below.</p>
                <div className='flex-row'>
                <div style={{ marginRight: "10px" }}>
                  <FaCheckCircle fontSize={40} color={"#02B4CC"}/>
                </div>
                <div>
                  <p style={{ marginBottom: "0px" }}><b>New Innovation Project or Initiative</b></p>
                  <p>Delivered new innovative solutions that redefine processes or elevate business outcomes to new levels with <b>high tangible impact*</b> and consider their BU performance. The employee must be the leader and/or key person of the innovation implemented.</p>
                </div>
              </div>
              <div className='flex-row'>
                <div style={{ marginRight: "10px" }}>
                  <FaCheckCircle fontSize={40} color={"#02B4CC"}/>
                </div>
                <div>
                  <p style={{ marginBottom: "0px" }}><b>Beyond Job Scope Project or Initiative</b></p>
                  <p>Demonstrated proactive involvement in activities or responsibilities outside their defined role or support other BU with <b>high tangible impact*</b>, with consideration to their performance in main role and BU performance. The employee must be the leader and/or key person of the innovation implemented.</p>
                </div>
              </div>
              <p>*) measurable and meaningful results that directly contribute to business performance.</p>

              <p>For more detailed information, please download the document <a href='https://drive.google.com/drive/folders/1jH4AoHvPAcbgymeLnovqvQmCea35giNh?usp=sharing'>here</a></p>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <ActionButtonGradient
                  onClick={handleClose}
                  variant='danger'
                  children={"Close"}
                />
            </Modal.Footer>
        </Modal>
    );
}

export default RatingGuidance